/**
 * PHRASE BLOOM の配色。
 *
 * ノブキャップの 5 色はサインインページ FlowingCircles のドットと同一
 * （src/pages/index/components/FlowingCircles.tsx）。
 * パネル面は Rupert Neve Designs Portico II へのオマージュとして
 * シルバーホワイト + 濃紺グレー刻印。ディスプレイ類は LCD 風の暗色を保つ。
 */

export const BLOOM_COLORS = {
  yellow: "#FFE100",
  blue: "#0066CC",
  cyan: "#00B4D8",
  orange: "#FF6B35",
  red: "#E71D36",
} as const;

export const PANEL = {
  faceTop: "#f5f7f9",
  faceBottom: "#dde3e8",
  border: "#a8b2bc",
  sectionBorder: "rgba(35, 45, 56, 0.24)",
  engraving: "rgba(35, 45, 56, 0.75)",
  engravingStrong: "#232d38",
  displayBg: "#10161d",
  displayText: "#dfe7ee",
  screw: "#8fa0b0",
  /** 白面上の目盛り・非アクティブ要素（刻印より薄い濃色） */
  tick: "rgba(35, 45, 56, 0.35)",
  /** フォーカスリング */
  focus: "rgba(35, 45, 56, 0.55)",
} as const;

/** パネル刻印用フォント（Typekit で読込済み） */
export const PANEL_FONT = '"din-2014", sans-serif';
